import { atomWithStorage } from 'jotai/utils'

import { STORAGE_KEY } from '@/constants/common'
import {
  // DEFAULT_FEE_MODE,
  DEFAULT_PREFERRED_EXPLORER,
  DEFAULT_RPC_ENDPOINT,
  // DEFAULT_TRANSACTION_BROADCASTING,
  DEFAULT_TRANSACTION_SETTING,
  // FeeMode,
  ITxSettingProps,
  PreferredExplorer
  // TransactionBroadcasting
} from '@/constants/settings'
import { TokenOrderColumn } from '@/hooks/services/useTokenList'
import { createIndexedDBStorage } from '@/stores/indexedDB'

export const preferredExplorerAtom = atomWithStorage<PreferredExplorer>(
  STORAGE_KEY.PEFERRED_EXPLORER,
  DEFAULT_PREFERRED_EXPLORER.url,
  undefined,
  {
    getOnInit: true
  }
)

export const rpcEndpointAtom = atomWithStorage<string>(
  STORAGE_KEY.RPC_ENDPOINT,
  DEFAULT_RPC_ENDPOINT.url,
  undefined,
  {
    getOnInit: true
  }
)

// export const transactionBroadcastingAtom =
//   atomWithStorage<TransactionBroadcasting>(
//     STORAGE_KEY.TRANSACTION_BROADCASTING,
//     DEFAULT_TRANSACTION_BROADCASTING.value,
//     undefined,
//     {
//       getOnInit: true
//     }
//   )

// export const feeModeAtom = atomWithStorage<FeeMode>(
//   STORAGE_KEY.FEE_MODE,
//   DEFAULT_FEE_MODE.value,
//   undefined,
//   {
//     getOnInit: true
//   }
// )

// export const feeAtom = atomWithStorage<string>(STORAGE_KEY.FEE, '', undefined, {
//   getOnInit: true
// })

// export const transactionSettingAtom = atomWithStorage<ITxSettingProps>(
//   STORAGE_KEY.TRANSACTION_SETTING,
//   DEFAULT_TRANSACTION_SETTING,
//   undefined,
//   {
//     getOnInit: true
//   }
// )

export const transactionSettingAtom = atomWithStorage<ITxSettingProps>(
  STORAGE_KEY.TRANSACTION_SETTING,
  DEFAULT_TRANSACTION_SETTING,
  createIndexedDBStorage(),
  {
    getOnInit: true
  }
)

export const eventNotificationsTimerAtom = atomWithStorage<number | string>(
  STORAGE_KEY.EVENT_NOTIFICATIONS_TIMER,
  '',
  undefined,
  {
    getOnInit: true
  }
)

export const tokenSortTypeAtom = atomWithStorage<TokenOrderColumn>(
  STORAGE_KEY.TOKEN_SORT_TYPE,
  TokenOrderColumn.CreateAt,
  undefined,
  {
    getOnInit: true
  }
)
